exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sb-news canvas{margin:0!important}.sb-news .sb-news-image-container img.sb-news-image{width:100%;height:auto}.sb-news .md-button{margin:6px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/news/news.scss
// module id = 578
// module chunks = 0